import React, { useMemo } from "react";
import { Sprite } from "@pixi/react";
import { getUITexture } from "../../../../assets";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import { PixiSettings } from "../../../../pixiSettings";

// Device-specific scale multipliers - same pattern as LogoLandscape/LogoPortrait
const DEVICE_CONFIG = {
  [PixiSettings.DEVICE.MOBILE]: {
    [PixiSettings.ORIENTATION.PORTRAIT]: { deviceMultiplier: 1.5 },
    [PixiSettings.ORIENTATION.LANDSCAPE]: { deviceMultiplier: 1.25 },
  },
  [PixiSettings.DEVICE.TABLET]: {
    [PixiSettings.ORIENTATION.PORTRAIT]: { deviceMultiplier: 1.3 },
    [PixiSettings.ORIENTATION.LANDSCAPE]: { deviceMultiplier: 1.2 },
  },
  [PixiSettings.DEVICE.DESKTOP]: {
    deviceMultiplier: 1.0,
  },
};

const CompanyLogo = ({ toolbar }) => {
  const { device, orientation, symbolScale } = useDimensions();
  const texture = getUITexture("company_logo");

  const deviceConfig = useMemo(() => {
    if (device === PixiSettings.DEVICE.DESKTOP) {
      return DEVICE_CONFIG[device];
    }
    return DEVICE_CONFIG[device]?.[orientation] || { deviceMultiplier: 1.0 };
  }, [device, orientation]);

  // Extract dimensions from texture and scale - preserves aspect ratio (same as LogoLandscape/LogoPortrait)
  const scaledDimensions = useMemo(() => {
    if (!texture) return { scaledWidth: 0, scaledHeight: 0 };
    const nativeWidth = texture.width;
    const nativeHeight = texture.height;
    const scale = deviceConfig.deviceMultiplier * symbolScale;
    return {
      scaledWidth: nativeWidth * scale,
      scaledHeight: nativeHeight * scale,
    };
  }, [texture, deviceConfig.deviceMultiplier, symbolScale]);

  // Same position for all devices
  const logoPosition = useMemo(
    () => ({
      x: toolbar.width / 2,
      y: toolbar.height / 2,
    }),
    [toolbar.width, toolbar.height],
  );

  const { scaledWidth, scaledHeight } = scaledDimensions;

  return (
    <Sprite
      name="secondary_company_logo"
      x={logoPosition.x}
      y={logoPosition.y}
      zIndex={3}
      texture={texture}
      anchor={0.5}
      width={scaledWidth}
      height={scaledHeight}
      resolution={2}
    />
  );
};

export default CompanyLogo;
